module.exports = __webpack_public_path__ + "profile-white-i.png";